import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "./routes/routes";
import { AuthContextProvider } from "./contexts/AuthContext";
import { ConfigProvider, message } from "antd";
import locale from "antd/locale/pt_BR";
import { theme } from "./constants/theme";

function App() {
  message.config({
    duration: 3,
    maxCount: 1,
    rtl: false,
    prefixCls: "",
  });

  return (
    <ConfigProvider theme={theme} locale={locale}>
      <AuthContextProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Routes />
        </BrowserRouter>
      </AuthContextProvider>
    </ConfigProvider>
  );
}

export default App;
